<template>
  <div class="signin-container">
    <div id="signin">
      <!-- <img src="../assets/Icons/signin.png" alt=""  > -->
      <div class="signin-form">
        <form @submit.prevent="onSubmit">
          <div class="input">
            <label for="username">username</label>
            <input type="username" id="username" v-model="username" />
          </div>
          <div class="input">
            <label for="password">Password</label>
            <input type="password" id="password" v-model="password" />
          </div>
          <div class="submit">
            <button @click="onSubmit">Submit</button>
          </div>
        </form>
        <output>{{ takeResults.length }}</output> <br />
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "../common/api.service";
import JwtService from "../common/jwt.service";

import { mapGetters } from "vuex";

export default {
  data() {
    return {
      username: "",
      password: "",
      tokenCheck: ""
    };
  },

  methods: {
    async fetchResults() {
      await this.$store.dispatch("getResults");

      for (let index = 0; index < this.takeResults.length; index++) {
        // console.log(this.takeResults[index]);
      }
    },
    async onSubmit() {
      try {
        ApiService.setBaseUrl();
        const { data } = await ApiService.post("auth/login/", {
          username: this.username,
          password: this.password
        });

        JwtService.saveToken(data.token);
        this.currentUser = data.user;
        this.tokenCheck = data.token;
      } catch (e) {
        console.log(e);
      }
      this.fetchResults();
    }
  },
  mounted() {
    for (let index = 0; index < this.takeResults.length; index++) {
      // console.log(this.takeResults[index].date_saved);
    }
  },
  computed: {
    ...mapGetters(["takeResults"]),

    imgsrc: function() {
      return require("../assets/Icons/icon1.png");
    }
  }
};
</script>

<style scoped>
.signin-container {
  height: 100%;
  width: 100%;
  /* background-image:url('../assets/Icons/signin.png') ; */
  background-color: green;
}

.signin-form {
  width: 400px;
  margin: 30px auto;
  border: 1px solid #eee;
  padding: 20px;
  box-shadow: 0 2px 3px #ccc;
}

.input {
  margin: 10px auto;
}

.input label {
  display: block;
  color: #4e4e4e;
  margin-bottom: 6px;
  color: #fff;
}

.input input {
  font: inherit;
  width: 100%;
  padding: 6px 12px;
  box-sizing: border-box;
  border: 1px solid #ccc;
}

.input input:focus {
  outline: none;
  border: 1px solid #521751;
  background-color: #eee;
}

.submit button {
  border: 1px solid #521751;
  color: #521751;
  padding: 10px 20px;
  font: inherit;
  cursor: pointer;
}

.submit button:hover,
.submit button:active {
  background-color: #521751;
  color: white;
}

.submit button[disabled],
.submit button[disabled]:hover,
.submit button[disabled]:active {
  border: 1px solid #ccc;
  background-color: transparent;
  color: #ccc;
  cursor: not-allowed;
}
</style>
